import script from "./CompletionAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionAccordion.vue?vue&type=style&index=0&id=72094740&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72094740"]])

export default __exports__